export function setShellEventOrRun(name, fn, setEventWhen = () => true) {
  if (window.shellLayout && setEventWhen()) {
    window.addEventListener(name, e => fn(e.detail), { once: true });
  } else {
    fn();
  }
}
